import { useEffect, useState } from 'react';
import { COMPUTE_PERFORMANCE_BASED_BONUS, useExpenseService } from 'domain/shared/expense';
import { ButtonWithConfirmation } from 'framework/ui/ui-builder';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import moment from 'moment';
import { DateInput } from 'framework/form';

type Props = any;

const DownloadBatchExpenseAccrualVerificationCsvButton = ({
  disabledInput = false,
  initialValue = '',
  ...props
}: Props) => {
  const { generateBatchExpenseAccrualVerificationCsv } = useExpenseService();
  const [dateErrors, setDateErrors] = useState<string[]>([]);
  const { getToday } = useDateService();
  const currentMonth = getToday().startOf('month').subtract(1, 'month');
  const [date, setDate] = useState<any>(initialValue || currentMonth);

  const onDateChange = (values: any) => {
    setDate(values.date);
    const isValid = moment(values.date, DATE_FORMAT.API_ONLY_MONTH, true).isValid();

    if (!values.date) {
      setDateErrors(['Field is required']);
    } else if (!isValid) {
      setDateErrors(['Please, choose the correct date']);
    } else if (moment(values.date, DATE_FORMAT.API_ONLY_MONTH, true).isAfter(currentMonth)) {
      setDateErrors(['Please, choose month earlier than current month']);
    } else {
      setDateErrors([]);
    }
  };

  useEffect(() => {
    if (initialValue) {
      onDateChange({ date: initialValue });
    }
    // Suppressed warnings because we only need to call useEffect callback if initialValue is changed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue]);

  return (
    <ButtonWithConfirmation
      displayMessage="Do you really want to download batch expense accrual verification report? Please, fill out the input below."
      modalChildren={
        <DateInput
          source="date"
          label="Period"
          onChangeCallback={onDateChange}
          errorMessages={dateErrors}
          isRequired
          dateFormat={DATE_FORMAT.API_ONLY_MONTH}
          value={
            date && moment(date, DATE_FORMAT.API_ONLY_MONTH, true).isValid()
              ? moment(date).format(DATE_FORMAT.API_ONLY_MONTH)
              : (date as any)
          }
          maxDate={currentMonth}
          disabled={disabledInput}
          sx={{ mt: 2.5 }}
        />
      }
      variant="outlined"
      submitMethod={() => generateBatchExpenseAccrualVerificationCsv(moment(date).format(DATE_FORMAT.API_ONLY_MONTH))}
      confirmBtnProps={{ disabled: !!dateErrors.length }}
      permissionToCheck={COMPUTE_PERFORMANCE_BASED_BONUS}
      afterSubmit={{
        successMessage: 'Batch expense accrual verification report was downloaded successfully.',
        errorMessage: "Can't download batch expense accrual verification report.",
      }}
      {...props}
    >
      Download accruals report
    </ButtonWithConfirmation>
  );
};

export default DownloadBatchExpenseAccrualVerificationCsvButton;
